// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2mHQp","content":"GlobalSearch_content__P5wEJ"};